import React, { useState, memo } from 'react';
import AccessControl from '../../../../shared/components/AccessControl';
import DataTable from '../../../../shared/components/DataTable';
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Card, CardBody, Col, ButtonToolbar, Badge } from "reactstrap";
import CustomSearch from '../../../Users/UsersList/components/CustomSearch';
import { reset } from 'redux-form';
import { MdArrowBack } from "react-icons/md";


const RecipientTable = memo((props) => {
    const { dataState, fetchData, recipients, dispatch } = props;
    const [searchKey, setSearchKey] = useState("");
    const count = dataState && dataState.response ? dataState.response.count : 0;
    
    const sortFn = (pageNum, pageSize, column) => {
        let sortOrder = "ASC";
        if (!recipients.loading) {
            if (recipients.request && recipients.request.sortOrder) {
                sortOrder = recipients.request.sortOrder === "ASC" ? "DESC" : "ASC";
            }
            fetchData({
                ...recipients.request,
                pageNum,
                pageSize,
                sortKey: column.sortKey,
                sortOrder,
            });
        }
    };
    const handleSubmit = (values) => {
        setSearchKey(values.searchKey);
        fetchData({
            ...recipients.request,
            pageNum: 1,
            searchKey: values.searchWord || "",
        });
    };
    const clearForm = () => {
        dispatch(reset("custom_search"));
        setSearchKey("")
    }
    const loadData = (pageNum, pageSize) => {
        fetchData({
            ...recipients.request,
            pageNum,
            pageSize,
            searchKey: searchKey,
        });
    };

    const columns = [
        {
            accessor: "beneficiaryPhoneNumber",
            name: "Recipient's Phone Number",
            filterable: true,
            sortable: true,
            sortKey: "beneficiaryPhoneNumber",
            Cell: (row) => <span>{row.beneficiaryPhoneNumber}</span>
        },
        {
            accessor: "amount",
            name: "Amount",
            sortable: true,
            sortKey: "amount",
            filterable: true,
            show: true,
            Cell: (row) => <span>{row.amount}</span>
        },
        {
            accessor: "status",
            name: "Status",
            sortable: true,
            sortKey: "status",
            filterable: true,
            show: true,
            Cell: (row) => <Badge color={row.status === "failed" ? "danger" : row.status === "pending" ? "info": "success"}>{row.status}</Badge>,
        },
    ];

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="card__title">
                        <h5 className="bold-text">
                            <Link to="/disbursement" id="link-all-users">
                                <MdArrowBack size={20} /> Back to Disbursement Table
                            </Link>
                        </h5>
                    </div>
                    <br />
                    <DataTable
                        columns={columns}
                        loading={dataState && dataState.loading}
                        data={dataState && dataState.response ? dataState.response.content : []}
                        countName="Recipient(s)"
                        count={count}
                        defaultPageSize={10}
                        clearSearch={clearForm}
                        defaultPageNumber={1}
                        loadData={loadData}
                        error={dataState && dataState.error}
                        bordered={true}
                        striped={true}
                        hover={true}
                        responsive
                        tableName="recipients"
                        customSearch={
                            <CustomSearch
                                pageNumer={1}
                                initialValues={{
                                    pageNumber: 1,
                                    pageSize: 10,
                                    searchKey: ""
                                }}
                                pageSize={10}
                                onSubmit={handleSubmit}
                                placeholder="Search"
                            />
                        }
                        sortFn={sortFn}
                        searchKey={searchKey}
                        serverside
                    />

                </CardBody>
            </Card>
        </Col>
    );
});

export default connect((state) => ({
    recipients: state.winnerDisbursement
}))(withRouter(RecipientTable));